import { render } from "./ReleaseDownload.vue?vue&type=template&id=29160bc6&scoped=true"
import script from "./ReleaseDownload.vue?vue&type=script&lang=js"
export * from "./ReleaseDownload.vue?vue&type=script&lang=js"

import "./ReleaseDownload.vue?vue&type=style&index=0&id=29160bc6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29160bc6"]])

export default __exports__